module.exports = __webpack_public_path__ + "static/media/location-pin-red.97ffbbda.svg";